import type { ExternalBranch } from '../../types';

export const isExternalBranch = (entity: any): entity is ExternalBranch =>
	entity.__typename === 'ExternalBranch';

export const getExternalBranchLink = (branch: ExternalBranch): string | null => branch?.url ?? null;
